<template>
  <div class="cont">

    <div class="login-container">
      <div class="login-box">
        <h1>Forgot Password</h1>
        <p class="subtext">Enter your email and we'll send you a link to reset your password.</p>

        <form @submit.prevent="handleSubmit" v-if="!submitted">
          <input type="email" placeholder="Email" v-model="email" required />
          <button type="submit" :disabled="loading">{{ loading ? 'Sending...' : 'Send Reset Link' }}</button>
        </form>

        <div v-else class="sent-message">
          <p>If that email is registered, a reset link is on its way. Check your inbox.</p>
        </div>

        <div class="signup">
          <p><router-link to="/login">Back to Sign In</router-link></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from 'vue-toastification';

export default {
  name: 'ForgotPasswordComponent',
  data() {
    return {
      email: '',
      loading: false,
      submitted: false,
      toast: useToast(),
      prodUrl: process.env.VUE_APP_PROD_URL,
    };
  },
  methods: {
    goBack() {
      if (window.history.state && window.history.state.back) {
        this.$router.back();
      } else {
        this.$router.push({ name: 'login' });
      }
    },
    handleSubmit() {
      this.loading = true;
      fetch(`${this.prodUrl}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: this.email }),
      }).then(async (res) => {
        this.loading = false;
        res = await res.json();
        if (res.success) {
          this.submitted = true;
        } else {
          this.toast.error(res.message || res.msg || 'Something went wrong. Please try again.');
        }
      }).catch(() => {
        this.loading = false;
        this.toast.error('An error occurred. Please try again.');
      });
    },
  },
};
</script>

<style scoped>
.cont {
  width: 100%;
  height: 100%;
  background: url('https://assets.nflxext.com/ffe/siteui/vlv3/6c6a5e8e-b88f-40c7-9dc2-2a2c0f4db2dc/fc5ffefb-7e42-4629-a0b1-8ebedb2ce2e8/IN-en-20230828-popsignuptwoweeks-perspective_alpha_website_large.jpg')
    center/cover no-repeat;
  display: flex;
  flex-direction: column;
  color: white;
  overflow-y: auto;
  scrollbar-width: none;
  display: grid;
  grid-template-rows: auto 1fr;
}

.login_heading {
  width: 100%;
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: left;
  margin-top: 1vh;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-box {
  padding: 0px 0vw;
  border-radius: 4px;
  width: 320px;
}

h1 {
  margin-bottom: 16px;
  font-weight: 600;
}

.subtext {
  color: #b3b3b3;
  font-size: 14px;
  margin-bottom: 24px;
  line-height: 1.4;
}

input {
  width: 100%;
  margin-bottom: 16px;
  padding: 14px;
  border: none;
  border-radius: 4px;
  background: #333;
  color: white;
  font-size: 14px;
}

input:focus {
  outline: 2px solid #e50914;
}

button {
  width: 100%;
  padding: 14px;
  background: #e50914;
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 4px;
  margin-top: 10px;
  cursor: pointer;
  transition: background 0.3s;
}

button:hover {
  background: #f6121d;
}

button:disabled {
  background: #7a0a0f;
  cursor: not-allowed;
}

.sent-message {
  color: #b3b3b3;
  font-size: 14px;
  line-height: 1.6;
  background: #222;
  padding: 16px;
  border-radius: 4px;
}

.signup {
  margin-top: 30px;
  font-size: 14px;
  color: #b3b3b3;
}

.signup a {
  color: white;
  text-decoration: none;
}

.signup a:hover {
  text-decoration: underline;
}

@media (max-width: 675px) {
  .login-box {
    width: 90vw;
    max-width: 320px;
  }
}
</style>
